import styled from "styled-components";
import dayjs from "dayjs";
import { Avatar } from "react-rainbow-components";

const SummaryContainer = styled.h1`
  text-align: center;
  font-size: 0.8rem;
  color: #123559;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 15rem;
  display: -webkit-box;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
`;

const TimestampContainer = styled.div`
  text-align: center;
  color: #123559;
`;

const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #123559;
  h1 {
    font-size: 16px;
    text-align: center;
    margin: 0;
  }
  h2 {
    font-size: 14px;
    margin: 0.5rem 0 0 0;
    text-align: center;
  }
`;

const ProfileContainer = styled.div`
  display: flex;
  align-self: center;
  justify-content: flex-start;
  align-items: flex-start;
  color: #123559;

  h1 {
    font-size: 18px;
    font-weight: 500;
    max-width: calc(15px * 12);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
    margin: 0;
  }
  h2 {
    font-size: 16px;
    font-weight: 300;
    max-width: calc(15px * 12);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
    margin: 0.25rem 0 0 0;
  }
`;

const ImageContainer = styled(Avatar)`
  margin-right: 1rem;
  width: 40px;
  height: 40px;
  min-width: 40px;
`;

export const TagInput = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 0 8px;
  border-radius: 6px;
  &:focus-within {
    border: 1px solid #123559;
  }
  input {
    flex: 1;
    border: none;
    height: 46px;
    font-size: 14px;
    padding: 4px 0 0 0;
    &:focus {
      outline: transparent;
    }
  }
  #tags {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 8px 0 0 0;
  }

  .tag {
    width: auto;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    padding: 0 8px;
    font-size: 14px;
    list-style: none;
    border-radius: 6px;
    margin: 0 8px 8px 0;
    background: #123559;
    .tag-title {
      margin-top: 3px;
    }
  }

  @media screen and (max-width: 567px) {
    .tags-input {
      width: calc(100vw - 32px);
    }
  }
`;

export const TextDescription = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: #8f939d;
  text-align: center;
`;

const ContainerTable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Summary = (props: { summary: string }) => {
  return (
    <ContainerTable>
      <SummaryContainer title={props.summary}>{props.summary}</SummaryContainer>
    </ContainerTable>
  );
};

export const Timestamp = (props: { timestamp: string | number | Date }) => {
  const date = dayjs(props.timestamp).format("DD/MM/YYYY");
  return <TimestampContainer>{date}</TimestampContainer>;
};

export const ProfileComponent = (props: {
  name: string;
  displayName: string;
  pictureUrl: string;
}) => {
  return (
    <ProfileContainer>
      <ImageContainer
        src={props.pictureUrl}
        title={props.name}
        assistiveText={props.name}
        initials={props.name}
      />
      <div>
        <h1>{props.name}</h1>
        <h2>{props.displayName}</h2>
      </div>
    </ProfileContainer>
  );
};

export const Product = (props: {
  productName: string;
  productPrice: number;
}) => {
  return (
    <ProductContainer>
      <h1>Package {props.productName}</h1>
      <h2>ราคา {props.productPrice} ฿</h2>
    </ProductContainer>
  );
};

export const RenderTags = (props: { tags?: string[] }) => {
  return (
    <TagInput>
      {props.tags &&
        props.tags.map((tag, index) => (
          <li key={index} className="tag">
            <span className="tag-title">{tag}</span>
          </li>
        ))}
    </TagInput>
  );
};

export const RenderDoctor = (props: { doctorId?: string }) => {
  return <SummaryContainer>{props.doctorId}</SummaryContainer>;
};
